export const MOST_PUPULAR_LANGUAGES = ['english', 'spanish', 'french', 'german'];
export const SOURCE = 'explicit_language_pair_filter';
export const LOCATION = 'Top Tile';
export const INCLUDED_QUERIES = ['translation', 'translate', 'translator', 'translations'];
